module.exports = __webpack_public_path__ + "img/gc_country_flag_be.0022b02e.svg";